export const formItemLayout = { labelCol: { span: 6 }, wrapperCol: { span: 12 } };
export const tailFormItemLayout = { wrapperCol: { offset: 8, span: 8 } };

export const formFieldLayout = { labelCol: { span: 6 }, wrapperCol: { span: 12 } };
export const formFieldWideLayout = { labelCol: { span: 4 }, wrapperCol: { span: 16 } };

export const formActionsLayout = { wrapperCol: { offset: 5, span: 13 } };
export const formSingleActionLayout = { wrapperCol: { offset: 0, span: 13 } };
export const modalFieldLayout = { labelCol: { span: 4 }, wrapperCol: { span: 20 } };
